module.exports = __webpack_public_path__ + "img/ring_skip_skip_null_1@2x.1157f103.png";